import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { loadDisplaySiteBuyById, clearSiteBuyStates, loadDisplaySiteBuyReport, loadSiteBuyOverviewData } from "../../redux/actions/site-buy-actions";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Breadcrumb, PageHeader, Tabs, Spin } from "antd";
import { compose } from "redux";
import SiteBuyDetails from "./site-buy-details";
import SiteBuyOverview from "./site-buy-overview";
import SiteBuyTags from "./display-site-buy-tags";
import SiteBuyReporting from "./display-site-buy-reporting";
import { currentUserPermissionMap } from "./../../constants/permissions";
import UserService from "./../../services/user-service";
import { getDayStartDateTime, getDayEndDateTime, getUTCDate } from "../../utils/appUtils";

const { TabPane } = Tabs;

const SiteBuy = ({ displaySiteBuy, siteBuyUpdated, siteBuyReport, siteBuyOverviewData }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [submitted, setSubmitted] = useState(false);
  const currentUser = UserService.getCurrentUser();
  const currentUserRole =
    currentUser && currentUser["roles"] && currentUser["roles"][0] ? currentUser["roles"][0] : "";

  useEffect(() => {
    let isMounted = true;

    let data = {};
    // data["startDate"] = getDayStartDateTime(new Date(new Date().getTime() - (60 * 60 * 24 * 7 * 1000)));
    // data["endDate"] = getDayEndDateTime(new Date());
    data["startDate"] = new Date(getUTCDate(getDayStartDateTime(new Date(new Date().getTime() - (60 * 60 * 24 * 7 * 1000))))).toUTCString();
    data["endDate"] = new Date(getUTCDate(getDayEndDateTime(new Date()))).toUTCString();
    data["systemTimezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    data["report"] = "Date - Delivery";
    data["id"] = id;
    data["timezone"] = "America/Los_Angeles";

    (async () => {
      setSubmitted(true);
      await dispatch(loadDisplaySiteBuyById(id));
      await dispatch(loadDisplaySiteBuyReport(data));
      await dispatch(loadSiteBuyOverviewData(id, "DISPLAY"));
      if(isMounted ){

      setSubmitted(false);
  }})();

    return () => {
      isMounted = false;

      console.log("EditSite Buy Unmounting");
      dispatch(clearSiteBuyStates());
    };
  }, [siteBuyUpdated]);

  return (
    <>
      <section className="white-box-wrapper">
        <Spin size={"large"} spinning={submitted}></Spin>
        {displaySiteBuy ? <><Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/publishers/${displaySiteBuy.publisher.publisherId}`}>Publisher</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/siteBuys/display-site-buy/${displaySiteBuy.displaySiteBuyId}`}>Site Buy</Link>
          </Breadcrumb.Item>
        </Breadcrumb></> : ""}
        <PageHeader className="site-page-header" title={displaySiteBuy && ` Display -  ${displaySiteBuy.name}`} />

        <Tabs defaultActiveKey="1" >
          <TabPane tab="Overview" key="overview">
            <SiteBuyOverview siteBuyType="display" siteBuyOverviewData={siteBuyOverviewData} />
          </TabPane>
          {currentUserPermissionMap[currentUserRole]["canAccessSiteBuyDetail"] ? (
            <TabPane tab="Details" key="details">
              <SiteBuyDetails siteBuy={displaySiteBuy} siteBuyType="display" />
              <SiteBuyTags siteBuy={displaySiteBuy} siteBuyType="display" />
            </TabPane>
          ) : (
            ""
          )}
          <TabPane tab="Reporting" key="reporting">
            <SiteBuyReporting siteBuyReport={siteBuyReport} />
          </TabPane>
        </Tabs>



      </section>
    </>
  );
};

function mapStateToProps(state) {
  return {
    displaySiteBuy: state.siteBuy.displaySiteBuy,
    siteBuyUpdated: state.siteBuy.siteBuyUpdated,
    siteBuyReport: state.siteBuy.siteBuyReport,
    siteBuyOverviewData: state.siteBuy.siteBuyOverviewData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadDisplaySiteBuyById: () => dispatch(loadDisplaySiteBuyById())
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(SiteBuy);
